import { render } from "./VariavelVisualizacao.vue?vue&type=template&id=56cf6c48&scoped=true&ts=true"
import script from "./VariavelVisualizacao.vue?vue&type=script&lang=ts"
export * from "./VariavelVisualizacao.vue?vue&type=script&lang=ts"

import "./VariavelVisualizacao.vue?vue&type=style&index=0&id=56cf6c48&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cf6c48"]])

export default __exports__